import { render, staticRenderFns } from "./PhotosUploadLocationSettings.vue?vue&type=template&id=13deca72&scoped=true"
import script from "./PhotosUploadLocationSettings.vue?vue&type=script&lang=js"
export * from "./PhotosUploadLocationSettings.vue?vue&type=script&lang=js"
import style0 from "./PhotosUploadLocationSettings.vue?vue&type=style&index=0&id=13deca72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13deca72",
  null
  
)

export default component.exports